import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IRouteStore } from '../stores/RouteStore';
import { ITranslateStore } from '../stores/TranslateStore';

interface DocumentTitleWrapperProps {
  titleTranslationKey: string;
  children: React.ReactNode;
  translateStore?: ITranslateStore;
  routeStore?: IRouteStore;
}

const DocumentTitleWrapper = (props: DocumentTitleWrapperProps): JSX.Element => {
  const { titleTranslationKey, children, translateStore, routeStore } = props;

  React.useEffect(() => {
    if (translateStore.isLoaded) {
      document.title = translateStore.translate(titleTranslationKey);
    }
  }, [translateStore.isLoaded, routeStore.pathName]);

  return children as JSX.Element;
};

export default inject('translateStore', 'routeStore')(observer(DocumentTitleWrapper));
